import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { Delete, Edit, Groups2Outlined } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import FlexBetween from "components/FlexBetween";
import moment from "moment";
import "moment/locale/id";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import { fetchAddPanduan, fetchDeletePanduan } from "state/panduanActions";
import AddPanduanModal from "components/Modals/AddPanduanModal";
import { BASEURL } from "api/axiosInstance";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import { fetchListAspirasi } from "state/aspirasiActions";
moment.locale("id");

const Aspirasi = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openAdd, setOpenAdd] = useState(false);
  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const { status, message } = useSelector((state) => state.global);
  const { list_aspirasi } = useSelector((state) => state.aspirasi);

  useEffect(() => {
    dispatch(fetchListAspirasi());
  }, []);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListAspirasi());
  };

  const handleSubmitPanduan = (value) => {
    dispatch(fetchAddPanduan(value));
  };

  const handleSelectedData = (id) => {
    let currentSelectedData = list_aspirasi.find((item) => item.id === id);
    setSelectedData(currentSelectedData);
  };
  const handleDelete = () => {
    dispatch(fetchDeletePanduan(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };

  const columnsPanduan = [
    {
      name: "id", // Kolom UUID
      label: "ID",
      options: {
        display: false, // Disembunyikan dari tampilan tabel
      },
    },
    {
      name: "id_karyawan",
      label: "Pembuat",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "masalah",
      label: "Masalah",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tujuan",
      label: "Tujuan",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "solusi",
      label: "Solusi",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "bukti1",
      label: "File Pendukung 1",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          const fileUrl = `${BASEURL}/files_aspirasi/${value}`;
          if (value === null || value === "") {
            return <span>Tidak ada file</span>;
          } else {
            return (
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "underline" }}
              >
                Pendukung 1
              </a>
            );
          }
        },
      },
    },
    {
      name: "bukti2",
      label: "File Pendukung 2",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          const fileUrl = `${BASEURL}/files_aspirasi/${value}`;
          if (value === null || value === "") {
            return <span>Tidak ada file</span>;
          } else {
            return (
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "underline" }}
              >
                Pendukung 2
              </a>
            );
          }
        },
      },
    },
    {
      name: "bukti3",
      label: "File Pendukung 3",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          const fileUrl = `${BASEURL}/files_aspirasi/${value}`;
          if (value === null || value === "") {
            return <span>Tidak ada file</span>;
          } else {
            return (
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "underline" }}
              >
                Pendukung 3
              </a>
            );
          }
        },
      },
    },
    // {
    //   name: "aksi",
    //   label: "Aksi",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       const id = tableMeta.rowData[0]; // Ambil ID dari kolom pertama
    //       return (
    //         <IconButton
    //           color="error"
    //           onClick={() => {
    //             setOpenKonfirmasi(true);
    //             handleSelectedData(id);
    //           }}
    //         >
    //           <Delete />
    //         </IconButton>
    //       );
    //     },
    //   },
    // },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    responsive: "standard",
    rowsPerPageOptions: [30, 60, list_aspirasi.length],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="Aspirasi"
        subtitle="Daftar aspirasi yang dikirimkan karyawan."
      />
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_aspirasi}
          columns={columnsPanduan}
          options={options}
        />
        <AddPanduanModal
          open={openAdd}
          onClose={() => setOpenAdd(false)}
          onSubmit={(value) => handleSubmitPanduan(value)}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={"Hapus"}
          subtitleType={"Menghapus"}
          dataWillProses={selectedData?.nama_sop}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => handleDelete()}
        />
      </Box>
    </Box>
  );
};

export default Aspirasi;
